import { useContext } from 'react';
import { Row } from 'react-bootstrap';
import { PermintaanProduksiContext } from '../../Context';
import { TableLC } from './TableLC';

export const ContainerLC = ({ showHistory }) => {
  const { dataLC } = useContext(PermintaanProduksiContext);

  return (
    <Row>
      <TableLC
        jobOrder
        showTotalPrice
        title="List Labour Cost Dari Job Order"
        data={dataLC.jobOrder}
      />
      <TableLC
        showInputRow
        showTotalPrice
        title="List Labour Cost"
        data={dataLC.permintaan}
      />
      {showHistory && (
        <TableLC
          readOnly
          title="History Permintaan Labour Cost"
          data={dataLC.history}
        />
      )}
    </Row>
  );
};
